import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useEFlyerQRCode } from './useEFlyerQRCode.js';

const QRCallToActionWeb = props => {
  const { callToAction, qrUrl } = props;
  return (
    <div className={'flex'}>
      <div>
        <EFlyerWebQRCode qrUrl={qrUrl} />
      </div>
      <div className={'ml-4 p-4 flex flex-col justify-center'}>
        <div className={'font-bold text-xl'}>{callToAction}</div>
        <div className={'text-xl pt-1'}>{qrUrl}</div>
      </div>
    </div>
  );
};

const EFlyerWebQRCode = ({ qrUrl, className, ...props }) => {
  const { qr } = useEFlyerQRCode(qrUrl);

  return (
    <div className={classNames('qr-code-container', className)} {...props}>
      <img src={qr} alt="QR Code" className="qr-code-image" />
    </div>
  );
};

EFlyerWebQRCode.propTypes = {
  /** The value to encode in the QR code */
  qrUrl: PropTypes.string.isRequired,
  /** Additional class names */
  className: PropTypes.string
};

export { QRCallToActionWeb };
